// GÉNÉRÉ par scripts/gen-versions.mjs — ne pas éditer à la main.
// Versions des packages @wp-reactor/* du monorepo, embarquées au build pour que
// le scaffold résolve __PKG_RANGE__ par package (cf. src/index.ts).
export const PACKAGE_VERSIONS: Record<string, string> = {
	"@wp-reactor/auth": "0.1.0",
	"@wp-reactor/block-editor": "0.7.3",
	"@wp-reactor/cli": "0.22.0",
	"@wp-reactor/commerce": "1.0.4",
	"@wp-reactor/config-biome": "0.2.1",
	"@wp-reactor/config-tsconfig": "0.1.0",
	"@wp-reactor/editorial": "1.1.3",
	"@wp-reactor/headless-core": "0.10.0",
	"@wp-reactor/ui": "0.3.0",
}
